// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"528":"codemirror","909":"notifications","961":"returns"}[chunkId] + "." + {"528":"dde3c144f64b968161e7","909":"ef48274c6e21eec2ece7","961":"5a1ceb09c100b9518a1c"}[chunkId] + ".css";
};